import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucUngDung } from './DanhMucUngDung.model';
import { BaseService } from './Base.service';

import { TruyXuatNguonGocToChuc } from './ToChuc.model';
import { TruyXuatNguonGocToChucService } from './ToChuc.service';
import { TruyXuatNguonGocThanhVien } from './ThanhVien.model';
import { TruyXuatNguonGocThanhVienService } from './ThanhVien.service';

@Injectable({
    providedIn: 'root'
})
export class DanhMucUngDungService extends BaseService {

    DisplayColumns001: string[] = ['STT', 'ID', 'Code', 'Name', 'Note', 'TypeName', 'Display', 'FileName', 'SortOrder', 'Active', 'Save'];

    constructor(

        public httpClient: HttpClient,
        public TruyXuatNguonGocToChucService: TruyXuatNguonGocToChucService,
        public TruyXuatNguonGocThanhVienService: TruyXuatNguonGocThanhVienService,

    ) {
        super(httpClient);
        this.Controller = "DanhMucUngDung";
    }
    GetLogin() {
        this.InitializationHeaders();
        this.BaseParameter.ID = Number(localStorage.getItem(environment.TruyXuatNguonGocDanhMucUngDungID));        
        if (this.BaseParameter.ID > 0) {

        }
        else {
            this.BaseParameter.TypeName = environment.TruyXuatNguonGocDanhMucUngDungToKen;
            this.GetByTypeNameAsync().subscribe(
                res => {
                    this.FormData = (res as DanhMucUngDung);
                    localStorage.setItem(environment.TruyXuatNguonGocDanhMucUngDungID, this.FormData.ID.toString());
                    localStorage.setItem(environment.TruyXuatNguonGocToKen, this.FormData.Description);
                    this.InitializationHeaders();
                },
                err => {
                },
                () => {
                    this.TruyXuatNguonGocToChucService.Sync(1);
                    this.TruyXuatNguonGocThanhVienService.Sync(1);
                }
            );
        }        
    }    
    GetByTypeNameAsync() {
        let url = this.APIURL + this.Controller + '/GetByTypeNameAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
}

